// extracted by mini-css-extract-plugin
module.exports = {"grid":"OurMakeChoice_grid__crj_d","item":"OurMakeChoice_item__RXjIF","text":"OurMakeChoice_text__JyH1f","iconBox":"OurMakeChoice_iconBox__cEk37"};